import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

wishListCardStyles.actionAddToCartButton = {
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
        border-radius: 25px;
        border: 1px solid ${COLORS.background.yellow};
        background-color: ${COLORS.background.yellow};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
        }
        &:hover {
            border: 1px solid ${COLORS.background.mango};
            background-color: ${COLORS.background.mango};
        }
        &:disabled:hover {
            border: 1px solid ${COLORS.disabled.base};
            background-color: ${COLORS.disabled.base};
        }
        display: none;
    `
}

wishListCardStyles.actionDeleteButton = {
    css: css`
        width: 100%;
        margin-top: 10px;
        border-radius: 25px;
        border: 1px solid ${COLORS.background.yellow};
        background-color: ${COLORS.background.yellow};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
        }
        &:hover {
            border: 1px solid ${COLORS.background.mango};
            background-color: ${COLORS.background.mango};
        }
        &:disabled:hover {
            border: 1px solid ${COLORS.disabled.base};
            background-color: ${COLORS.disabled.base};
        }
    `,
}

wishListCardStyles.actionLeaveButton = {
    css: css`
        width: 100%;
        margin-top: 10px;
        border-radius: 25px;
        border: 1px solid ${COLORS.background.yellow};
        background-color: ${COLORS.background.yellow};
        > span {
            color: ${COLORS.black} !important;
            font-family: ${TYPOGRAPHY.fontFamily.dosis};
        }
        &:hover {
            border: 1px solid ${COLORS.background.mango};
            background-color: ${COLORS.background.mango};
        }
        &:disabled:hover {
            border: 1px solid ${COLORS.disabled.base};
            background-color: ${COLORS.disabled.base};
        }
    `,
}

wishListCardStyles.wishListInfoGridItem = {
    width: [10, 10, 8, 9, 9],
}

wishListCardStyles.actionGridItem = {
    width: [2, 2, 4, 3, 3],
    align: "top",
    css: css`
        justify-content: flex-end;
    `,
}

wishListCardStyles.gridContainer = {
    gap: 5,
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
        }
    `,
}

wishListCardStyles.productImagesGridItem = {
    width: [12, 12, 12, 7, 7],
    css: css`
        flex-wrap: wrap;
    `,
}

wishListCardStyles.sharingStatusGridItem = {
    width: [12, 12, 12, 5, 5]
}

wishListCardStyles.sharingStatus = {
    statusText: {
        css: css`
            > div[class^="TooltipWrapper"] {
                margin-left: 5px;

            }
        `,
    },
}